import clsx from "clsx";

import styles from "./employee-progression-hero.module.css";

const HERO_ILLUSTRATION = "/assets/images/organization_structure_icon.png";

export interface EmployeeProgressionHeroProps {
  title?: string;
  description?: string;
}

export function EmployeeProgressionHero({
  title = "Employee Workflow Management",
  description = "Streamline reporting and leave manager assignments, promotion workflows, and document approvals from a single workspace.",
}: EmployeeProgressionHeroProps) {
  return (
    <section
      className={styles.hero}
      aria-labelledby="employee-progression-hero-heading"
    >
      <div className={styles.row}>
        <div className={styles.copy}>
          <h1
            id="employee-progression-hero-heading"
            className={clsx("heading-lg", styles.title)}
          >
            {title}
          </h1>
          <p className={clsx("sub-heading-sm", styles.subtitle)}>
            {description}
          </p>
        </div>
        <div className={styles.art} aria-hidden>
          <img
            src={HERO_ILLUSTRATION}
            alt=""
            className={styles.heroImg}
            width={320}
            height={160}
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}

